import { useState, useEffect } from "react";

export const useInvoiceStateManagement = ({ currentInvoice, company }) => {
	const [isModalOpenSend, setIsModalOpenSend] = useState(false);
	const [isr, setIsr] = useState(false);
	const [sendWithIsr, setSendWithIsr] = useState(false);

	const isISRApplicable = () => {
		const hasIsrFrase = company.database
			? currentInvoice.tax_authority_specifications.frases.some(
				(frase) => frase.type === 1 && frase.scenario === 2
			) : false;

		return (
			(currentInvoice.moneda === "GTQ" && currentInvoice.gran_total >= 2800 && hasIsrFrase) ||
			(currentInvoice.moneda === "USD" && hasIsrFrase)
		);
	};

	const findAccountNameById = (accountingPlan, accountId) => {
		// Buscar el elemento en accountingPlan que tenga un id que coincida con accountId
		const matchingElement = accountingPlan.find(planItem => planItem.id.toString() === accountId.toString());
      
		// Si se encuentra un elemento coincidente, retorna su propiedad 'name'
		if (matchingElement) {
			if (!matchingElement.display_name) {
				return matchingElement.name;
			}
			return matchingElement.display_name;
		} else {
			// Si no se encuentra ninguna coincidencia, retorna null o un mensaje indicativo
			return null; // o "No matching account found"
		}
	};

	useEffect(() => {
		setIsr(isISRApplicable());
	}, [currentInvoice, company]);

	return {
		isModalOpenSend,
		isr,
		sendWithIsr,
		findAccountNameById,
		openModal: () => setIsModalOpenSend(true),
		closeModal: () => setIsModalOpenSend(false),
		toggleIsr: (checked) => setSendWithIsr(checked),
	};
};
